import React from 'react';

export interface IMenu {
    anchorEl?: HTMLElement,
    isOpen: boolean,
    handleItemClick: (callback?: CallableFunction) => VoidFunction,
    open: (anchorEl: HTMLElement) => void,
    close: () => void    
    handleOpen: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
}

export function useMenu(){
    const [_anchorEl, _setAnchorEl] = React.useState<HTMLElement>();

    const close = React.useCallback(() => {
        _setAnchorEl(undefined);
    }, []);

    const handleItemClick = React.useCallback((callback?: CallableFunction) => () => {
        close();
        
        if (callback !== undefined) {
            callback();
        }
    }, [close]);

    const open = React.useCallback((anchorEl: HTMLElement) => {
        _setAnchorEl(anchorEl);
    }, []);

    const handleOpen = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        const anchorEl = e.currentTarget;
        open(anchorEl);
    }, [open])

    return {
        anchorEl: _anchorEl,
        isOpen: !!_anchorEl,
        handleItemClick,
        open,
        close,
        handleOpen
    }
}